import getLanguageByPath from '@src/utils/locale/getLanguageByPath.js';
import mergeLocalesData from '@src/global-locales/utils/merge-locales-data.js';
import getLanguageFolderName from '@src/utils/locale/getLanguageFolderName.js';

const languageFilePath = getLanguageByPath() === 'zh-cn' ? '' : `${getLanguageFolderName()}/`;

/**
 * @name pageLocalesData
 */
const pageLocalesData = {
  // 通用
  cookieInfo: {
    perference_settings: 'Perference Settings',
    cookie_description:
      'We use necessary cookies to ensure our website functions properly. Additionally, we also wish to employ optional cookies (including those from third-party partners) to enhance your experience and analyze site usage. For more details, please refer to our<a href="{link}" target="_blank" >Cookie Policy</a>.',
    settings_description:
      'Cookies and similar technologies may be used to store or retrieve information during your visit. While cookies are necessary for basic site functions, you can choose to disable certain types. Note that this may impact your experience.',
    necessary_cookies: 'Necessary Cookies',
    necessary_cookies_description: 'Necessary for enabling basic website functionalities, you cannot disable necessary cookies.',
    analytics_cookies: 'Analytics Cookies',
    analytics_cookies_description: '帮助网站运营商了解其网站的运行情况、访问者如何与网站互动以及是否可能存在技术问题。',
    view_details: ' View Details',
    _ga_description: '生成有关访客如何使用我们的服务的统计数据',
    _ga_duration: '1年',
    _ga_x_description: '生成有关访客如何使用我们的服务的统计数据',
    _ga_x_duration: '1年',
    _gid_description: '生成有关访客如何使用我们的服务的统计数据',
    _gid_duration: '1天',
    session_id_description: '保存用户登录状态相关信息',
    session_id_duration: '3小时（有访问会续期）',
    cookie_flag_description: '用于保存用户cookie设置状态',
    cookie_flag_duration: '90天',
    label_name: '名称',
    label_provider: '提供者',
    label_duration: '持续时间',
    label_description: '说明',
    confirm_btn: 'Confirm',
    allow_all_btn: 'allowAll',
    cookie_setting_btn: 'cookie设置',
    reject_all_cookies: '拒绝所有的cookies',
    allow_all_cookies: '接受所有的cookie',
    orientation_text: '请使用竖屏模式访问效果更佳',
    orientation_btn_text: '继续访问'
  },
  reserve: {
    button: '立即预约',
    button2: '预约有礼',
    exit: '退出',
    alreadyBooked: '您已预约',
    success: {
      title: '已注册',
      tips: 'Follow us for more updates',
      btnConfirm: '确定'
    },
    form: {
      phone: '手机号',
      email: '邮箱',
      vcode: '验证码',
      get_code: '[获取验证码]',
      resend: '重新发送'
    },
    logic: {
      need_agreement: '请先勾选同意隐私条款',
      need_email: '请输入邮箱账号',
      need_phone: '请输入手机号',
      need_vcode: '请输入验证码',
      has_success: '已预约成功',
      auto_close: '{second}（s）后自动关闭',
      phone_format: '请输入正确的手机号码',
      email_format: '请输入正确的邮箱',
      vcode_countdown: '{countdown}（s）后重试'
    },
    agreement: {
      agreement1: '《西山居用户协议》',
      agreementLink1: 'www.baidu.com',
      agreement2: '《西山居用户个人用户信息及隐私保护政策》',
      agreementLink2: 'www.baidu.com',
      desc: '我已阅读并同意<a t href="//{arg1Link}" target="_blank">{arg1}<a/><a href="//{arg2Link}" target="_blank">{arg2}<a/>'
    }
  },
  global: {
    comming_soon: 'coming soon',
    copy_success_tips_text: '复制成功'
  },
  // 顶部导航栏
  topBar: {
    item1: '首页',
    item2: '新闻资讯',
    item3: '游戏介绍',
    item4: '活动专区',
    item5: '礼包直购',
    item6: '关注我们',
    item7: 'FAQ',
    level2Item1: '游戏玩法',
    level2Item2: '机兵介绍',
    level2Item3: '王牌序列',
    level2Item14: '边缘战场',
    level2Item4: '世界观',
    level2Item5: '创作者活动',
    level2Item6: 'Twitch Drops',
    level2Item7: '先驱小队活动',
    level2Item8: '特装机典藏版',
    level2Item9: '特式機典藏版(Amazon US)',
    level2Item10: '特式機典藏版(Amazon JP)',
    level2Item11: '造型排行榜',
    level2Item12: '玛什玛克攻略站',
    level2Item13: '客服中心',
    level2Item15: '王牌档案',
    level2Item16: '壁纸',
    level3Item11: '风暴计划',
    loginBtn: '登录',
    logout: '退出'
  },
  // 底栏
  footer: {
    privacy_policy: '隐私政策',
    terms_of_service: '服务条款',
    all_rights: 'SEASUN GAMES PTE. LTD. All rights reserved.',
    cookie_agreement: 'cookie协议',
    cookie_setting: 'cookie设定',
    privacy_agreement: '隐私权政策',
    right_of_useAgreement: '使用权协议',
    corporation: ' ',
    purchase: ' ',
    funds_ja: ' ',
    acquisition_ja: ' ',
    zh_text: ' '
  },
  main: {
    giftPackCopyText: 'Link copied. Paste it into your PC browser to open.',
    title: "[ Mecha BREAK Collector's Bundle ]",
    giftModalText1: 'Only available on the Amazon US (Amazon.com) and Amazon Japan (Amazon.co.jp) sites.',
    giftModalText2: 'Please visit the corresponding site based on your shipping address to place an order.',
    giftModalText3:
      "This product is sold on Amazon and follows Amazon's Terms of Service and Privacy Policy. Proceeding with the purchase indicates that you acknowledge and accept these terms.",
    giftModalBtnText1: 'Amazon US',
    giftModalBtnText2: 'Amazon JP',
    eventEnds: '活动已结束',
    // 公测礼包弹窗
    giftPackModal: {
      giftPackBtn: '领取奖励',
      copyBtn: '复制',
      title: '领取礼包码',
      tips: '請前往遊戲內 選單-禮品兌換 處輸入禮包碼進行兌換',
      tips2: '*每位用户仅限兑换一次'
    }
  },
  downloadModal: {
    text1: 'Copy the link and open it on your PC to download Mecha BREAK',
    btnText: '复制链接'
  },
  feature: {
    feature1_text1: '弹幕交织，光刃相接',
    feature1_text2: '高速机动下的陆空作战',
    feature2_text1: '涂装改造，深度定制',
    feature2_text2: '每一处细节都交由你打造',
    feature3_text1: '涂装改造 搜索、清除、撤离 ',
    feature3_text2: '突入危险区域，解除世界危机',
    feature4_text1: '定制驾驶员，巡游基地',
    feature4_text2: '战斗之余，体验驾驶员日常',
    text: 'FEATURE'
  },
  mecha_unit: {
    Voiced_by_text1: '中文',
    Voiced_by_text2: '英文',
    Voiced_by_text3: '日文',
    mecha_baseInfo_title: '基础信息',
    driver_cv_title: '配音者',
    mecha_story_title: '机兵故事',
    mecha_factory_title: '生产商',
    falcon: {
      driver_role_title: '矛隼-角色经历',
      driver_sex: 'Sex: Female',
      driver_birth_place: 'Birthplace:Heralande, Cygnia Union',
      driver_mecha_name: 'Striker: FALCON CUSTOM',
      driver_role_desc:
        '莱奥妮·菲尔驾驶着矛隼特装型从空中掠过，侦察着敌方的动向，这种熟悉的感觉让她又想起了自己在联合空军服役的日子。相似，却又不同，曾经的她作为明星驾驶员，总在媒体的聚光灯之下，如今却只有少数人知晓她是S.H.A.D.O.W.的重要战力。莱奥妮的父亲克莱蒙·菲尔是环海能源的前董事长，曾经的莱奥妮也认为自己会跟随父亲的脚步，在大学毕业后学习如何打理家族产业，走上经商之路。然而父亲在边境地区遇害后，她舍弃了所有“既定的道路”，不顾一切去调查事故的真相。虽然最终功亏一篑，但在过程中她接触到了父亲资助的“边境路网”组织，也逐渐理解了父亲所真正的追求。返回联合体以后，莱奥妮毅然选择了投身战场，以自己的方式来实现父亲的愿望，实现自己的荣誉与理想。然而，过去的阴影并未消失，他们想要除掉莱奥妮，彻底控制环海能源。莱奥妮多次因来路不明的袭击陷入危机，她被迫在边境路网的协助下，由明转入暗，但她也终于抓住了真相的线索，等待着夺回一切的那一天。',
      Voiced_name1: 'Ali  Hillis',
      Voiced_name2: '小清水亚美',
      Voiced_name3: '黄莺',
      phrase1: '莱奥妮·菲尔！矛隼驾驶员，很高兴认识你，祝我们合作愉快！',
      phrase2: '该我和矛隼上阵了么。',
      phrase3: '胜利之光与矛隼共舞！',
      mecha_number: 'Model Number: UBP-R02C',
      mecha_head_height: 'Height: 15.0 m',
      mecha_empty_weight: 'Tare Weight: 17.7 t',
      mecha_full_weight: 'Gross Weight: 21.9 t',
      mecha_story_desc:
        'As the sixth VALRAVN prototype, this Striker integrated MindBridge technology and excelled as a test platform for the Union\'s advanced sensors, demonstrating significantly enhanced situational awareness compared to its predecessors. Military testers, impressed by its performance, recommended the development of a specialized reconnaissance model. This led to the creation of FALCON, a version equipped with fewer weapons but a superior cascade engine and enhanced sensors.Once FALCON entered mass production, the original prototype was retired and acquired by Oak Biotech\'s neuroscience department to advance their research in MindBridge technology. There were rumors that during a routine test, the Striker was lost due to Corite contamination and transformed into a Wraith Striker. The full story behind what was initially called an "accident" only became clear when the Striker unexpectedly reappeared years later with the S.H.A.D.O.W. special task force.',
      mecha_factory_name: 'Bifrost Industry Corporation'
    },
    stellarus: {
      driver_role_title: '飞景-角色经历',
      driver_sex: '性别：男',
      driver_birth_place: '出生地：罗迦共和国',
      driver_mecha_name: '搭乘机体：飞景改装型',
      driver_role_desc:
        '014这个编号是他的名字，作为战争机器诞生于培养舱，时任风标航运高层的父亲阿德里安还给了他另外的名字“陆回”。阿德里安的孩子陆回，从一出生就被训练成绝对忠诚于风标航运的战斗者，好在母亲的陪伴使得他黑暗的童年有了光亮。母亲不知去了哪里，成年后他奉阿德里安之命潜入薪火重工盗取“飞景”机兵数据时，一直在寻找母亲的下落。然而在薪火重工，他没料到会遇见众多战友，教会了战争机器何为战友的温度。陆回从阿德里安的掌控中叛逃。在风标航运，阿德里安的“女王蜂”计划正在进行。“女王蜂”连接着杀戮机器，那就是陆回的克隆人们，014是其中之一。014为父亲执行任务，以为自己是陆回，当他发现真相、当陆回把“飞景”交给他时，钢铁羽翼下他明白了存在的意义。014与陆回联手摧毁“女王蜂”，沉重打击风标航运和阿德里安的阴谋，也终于让母亲解脱。',
      Voiced_name1: 'Griffin Puatu',
      Voiced_name2: '千叶翔也',
      Voiced_name3: '马洋',
      phrase1: '014，战前准备完成，随时出发。',
      phrase2: '014报道，你可以称我陆回。',
      phrase3: '清剿完成，目标失去战斗能力。',
      mecha_number: '机体编号：PGI-T27G3 ',
      mecha_head_height: '头顶高：16.6 米',
      mecha_empty_weight: '空重：17.2 吨',
      mecha_full_weight: '全重：23.3 吨',
      mecha_story_desc: '占位，目前文案没定',
      mecha_factory_name: '薪火重工'
    },
    baihong: {
      driver_role_title: '白虹-角色经历',
      driver_sex: '性别：女',
      driver_birth_place: '出生地：月海共同体',
      driver_mecha_name: '搭乘机体：白虹特装型',
      driver_role_desc:
        '吉娜是月球地球最有人气的歌星，也是背负血仇的机甲战士。吉娜的歌声曾抚慰过无数移民月球却生活在底层的“后来者”，而现在她驾驶着"白虹"正穿梭于弹火之中。年少时与父亲哥哥分开，和母亲在月面大都市生活，18岁横跨地月成为超级巨星时，却不知父亲凯恩早已暗中领导着月球底层反抗组织"特伊亚"。命运的转折始于一场巡演，当她在反抗军基地与父亲重逢，目睹人们的艰辛与困苦，目睹父亲向贫民窟鞠躬，吉娜的音乐开始染上抗争的血色。太空电梯落成典礼本该是她又一次艺术巅峰，崩塌的太空电梯碎片却夺去了数十万生命，袭击者竟是高喊着"革命需要牺牲"的亲哥哥。父亲倒在哥哥的枪响下，昔日温柔的兄长已成恶魔，操控着更名"特伊亚战线"的武装集团对地月进行暴力打击。而今吉娜成为S.H.A.D.O.W.行动队的一员，“白虹”摧毁阴谋时，驾驶舱里永远循环着那首未完成的安魂曲，紧握操纵杆的吉娜说道："我只想亲眼看着哥哥戴上镣铐。"',
      Voiced_name1: 'Kimberly Brooks',
      Voiced_name2: '内田真礼',
      Voiced_name3: '陶典',
      phrase1: '吉娜，嗯~是我，（笑）唱歌舞蹈我擅长，但是驾驶机兵我还要跟大家好好学习。',
      phrase2: '和你待在一起，我总有很多创作灵感~',
      phrase3: '你别不服气，驾驶员里我也是大明星~',
      mecha_number: '机体编号：MHI-SR00',
      mecha_head_height: '头顶高：16.2 米',
      mecha_empty_weight: '空重：19.9 吨',
      mecha_full_weight: '全重：22.8 吨',
      mecha_story_desc:
        '这台“白虹”是摩诃重工生产的第一台意识投影型机兵，与“龙渊”同源，均为同盟开发意识投影的技术原型之一。边境战争后期，月海共同体以慷慨的援助诱使兀廷联邦共和国脱离同盟加入月球阵营，借此获得了意识投影技术和这台原型机。月球当局曾试图以该机先进的电子战系统引导卫星炮，一举歼灭月面反抗组织“特伊亚”，却不料该机反被对方俘获，计划也随之泄露。特伊亚受此事刺激行事日益激进，稳健派领袖被迫驾驶本机保护追随者逃离组织。该机加入S.H.A.D.O.W.行动队后，薪火重工扬其所长，为其配备了一架重型炮击无人机，从战场上空降下垂直狙击扫除该机指示的敌人。',
      mecha_factory_name: '摩诃重工'
    },
    narukami: {
      driver_role_title: '鸣神-角色经历',
      driver_sex: '性别：女',
      driver_birth_place: '出生地：羽州国',
      driver_mecha_name: '搭乘机体：鸣神 特式',
      driver_role_desc:
        '直到最近，神谷花音才终于习惯这个新名字。这位温婉端庄的大小姐是神谷财团派驻S.H.A.D.O.W.行动队的代表，她和她的机兵“鸣神”象征着神谷家族对边境路网无保留的支持与信任——这些当然只是外交辞令。只有少数人知道，两年前花音是孤身逃离封闭的岛舰，那时被强加的“神谷”之名是束缚着她的最后一条枷锁。加入S.H.A.D.O.W.行动队是花音第一次离开和平的家乡。那时她虽有两千次模拟战击坠但缺乏实战经验、温柔隐忍的性格似乎也不适合残酷的战场，难免引来许多风言风语。但这只持续到她的第一次任务——她和她的“鸣神”展现了超乎想象的娴熟……和冷漠，精准的狙击没有一丝犹豫。花音的奇妙反差并非无迹可寻，与她相熟之后其实不难发现她隐藏在优雅笑容下的“本性”：热衷练枪、擅长吵架、喜欢画漫画、讨厌神谷家……',
      Voiced_name1: 'Erika Harlacher-Stone',
      Voiced_name2: '花守由美里',
      Voiced_name3: '张琦',
      phrase1: '我叫神谷花音，请多指教。总算正式见面了，我听过很多有关你的故事，可以告诉我更多吗。',
      phrase2: '该去刷新鸣神的战绩了。',
      phrase3: ' 扣动扳机即分胜负，这就是鸣神。',
      mecha_number: '机体编号：KMA-D201S',
      mecha_head_height: '头顶高：14.8 米',
      mecha_empty_weight: '空重：17.2 吨',
      mecha_full_weight: '全重：20.9 吨',
      mecha_story_desc:
        '神谷花音的爱机是“鸣神”的第一台原型机。该机贵为羽州首台意识投影型机兵，肩负着为岛舰测试意识投影技术的重任。这位神谷家“大小姐”受命运引导登上并启动了“鸣神”，却又巧妙借助“鸣神”的力量一举逃离牢笼，挣脱了命运的操弄。花音携机加入本队之后，薪火重工不仅将她的机兵升级至解限型规格，还以之作为超微成像单元“星尘”的测试平台，验证了光学迷彩、质量投影等奇妙的电子战装备。依照协议，这台“鸣神”的战斗和测试数据均会回传神谷家，作为花音拥抱自由的交换条件。花音隐匿于光学迷彩之下射落对手时，或许也会回想起她初次坐进驾驶舱的那个遥远下午。',
      mecha_factory_name: '神谷重工'
    },
    welkin: {
      driver_role_title: '赤霄-角色经历',
      driver_sex: '性别：女',
      driver_birth_place: '出生地：沃图里亚战略同盟 玉梁',
      driver_mecha_name: '搭乘机体：赤霄 特装型',
      driver_role_desc:
        '"很多S.H.A.D.O.W.的同僚会因为苍绿的发色注意到可爱的向蕊，但见识过驾驶赤霄的她如旋风般席卷战场后，这个印象却又被完全颠覆。向蕊是整备班的常客，在机械领域有过人理解的她甚至能用几台报废机体重组出一台能动的机兵，这都要归功于她自幼就跟随机械师父亲漂泊的那些日积月累。如果当初父女的行踪没有被风标航运发现，现在的她可能还过着无拘无束的日子，可现实降予她的却是带着父亲托付的密件，独自驾驶残破机体对抗风标航运的追兵，辗转逃亡......直到向蕊成功接触边境路网，她才知晓自己保全的密件竞是足以改变世界格局的机兵技术。如今的向蕊时刻都充满着活力，即使驾驶赤霄作战时也同样自由奔放，积极乐观的战斗态度总能鼓舞到协同出击的队友，或许她早已将过去在逆境中的积累化作了今后前进的动力。"',
      Voiced_name1: 'Xanthe Huynh',
      Voiced_name2: '古贺葵',
      Voiced_name3: '陈奕雯',
      phrase1: '向蕊～记住不要读错了哦~别看我个子小，我就是开背后这台大块头的！流浪车队的那些孩子都得叫我姐姐。',
      phrase2: '来了来了！是有机械零件要给我吗？',
      phrase3: '赤霄，是爸爸留下的希望之光！',
      mecha_number: '机体编号：PGI-T02C',
      mecha_head_height: '头顶高：15.7 米',
      mecha_empty_weight: '空重：31.2 吨',
      mecha_full_weight: '全重：40.1 吨',
      mecha_story_desc:
        '"向蕊视若至宝的这台“赤霄”是对S.H.A.D.O.W.行动队也意义非凡的重要机兵。它曾只是欧冶电科流水线上一台平平无奇的战争机器，将以“武人”之名为同盟克敌制胜。然而，未来学会与薪火重工相继成立，同盟将这台尚未完工的机兵选为赠予未来学会的出生礼，寄望它能为褪色危机阴霾下的世界开辟未来。薪火重工接手该机的后续建造，为其搭载了尚在工程原型阶段的解限型意识投影系统。很长一段时日，本机都在未来学会麾下测试各类用于褪色区探索的特种防护装备，直到某日一位少女携着父亲的遗物前来拜访未来学会。其父留下的研究资料成就了本机最具代表性的力场武装，少女也凭从其柔弱外表难以想象的坚韧意志突破层层考核加入S.H.A.D.O.W.行动队成为驾驶员，如愿乘上这台承载着父亲心血与遗念的强大机兵。"',
      mecha_factory_name: '薪火重工'
    },
    tricera: {
      driver_role_title: '三角龙-角色经历',
      driver_sex: '性别：男',
      driver_birth_place: '出生地：环塔拉萨洋联邦 柯斯托克',
      driver_mecha_name: '搭乘机体：三角龙 特装型',
      driver_role_desc:
        '如果问起对查尔斯·贝尔的第一印象，S.H.A.D.O.W.行动队全员想必都会回答“老兵”。这位经验丰富的驾驶员早在大灾难前就在柯斯托克陆军服役，是队中最受信赖的前线指挥，也是最受畏惧的魔鬼教官。入队伊始，查尔斯也曾尝试维持威严冷峻的硬汉形象，可惜他收养的孩子们不断寄来涂鸦、布偶、木雕和护身符，总让他没办法藏起笑意。他很少提起，这些孩子们曾和他一起经营餐厅，生活艰苦却也温馨；他绝不会忘记，养女安卡的“奇迹之子”能力遭人觊觎，他的家乡因此被佣兵夷为平地。此事令查尔斯决心重回战场——即使这意味着他只能将孩子们送入掩体城市接受组织庇护，无法陪伴他们成长。近来要强的安卡也追随查尔斯入了队，这令他时不时就会被队员半开玩笑地叫作“岳父”。如今安卡仍是他最担心的孩子，不过担心的内容显然有所变化……',
      Voiced_name1: 'Robbie Daymond',
      Voiced_name2: '小山力也',
      Voiced_name3: '刘以嘉',
      phrase1: '查尔斯·贝尔中校！前来报道！突然把我从边境路网转调到这里，一定是有要紧的任务吧，期待组织的安排。',
      phrase2: '说吧，什么时候出击。',
      phrase3: '三角龙就是守护者的象征！',
      mecha_number: '机体编号：SLM-X324C',
      mecha_head_height: '头顶高：17.3 米',
      mecha_empty_weight: '空重：41.5 吨',
      mecha_full_weight: '全重：54.5 吨',
      mecha_story_desc:
        '老兵查尔斯的爱机“三角龙”原本属于二代机兵“恐龙”的极初期生产批次，早在南部战争期间就已服役。查尔斯携机加入边境路网时不少同僚猜测他会换乘新锐的“雷龙”，他却选择说服薪火重工将他的老搭档升级至解限型规格。薪火重工推出的一揽子升级方案以查尔斯爱机的昵称“三角龙”命名，囊括了解限系统和与之匹配的传感器、聚合物肌肉，还引入战术变形机能，令该机可以定点驻扎展开为重甲炮台。“三角龙”足以对抗最先进的解限型机兵，业已被视为旧型机升级的标杆之作。现时各方保有的“恐龙”超过三千台，已有多个组织斥资引进“三角龙”改装，令薪火重工一举跻身头部厂商的行列。',
      mecha_factory_name: '萨勒姆电气'
    },
    inferno: {
      driver_role_title: '地狱火-角色经历',
      driver_sex: '性别：女',
      driver_birth_place: '出生地：兀廷联邦共和国',
      driver_mecha_name: '搭乘机体：地狱火试验型',
      driver_role_desc:
        '赛迪莱妮是S.H.A.D.O.W.行动队最神秘的驾驶员，没有之一。多数队员对她的了解仅限于“赛迪莱妮”并非本名而是行动代号，即使是八面玲珑、消息灵通的琪娅拉，也仅仅比别人多知道一条从队医那儿打听来的“她是强化人”。当然“神秘感”的主因之一是她精神不稳定令人很难接近，但根源还是在于她失去了记忆。名字、经历、情谊、梦想——她脑中的一切早已因强化人改造的副作用支离破碎，求助于最好的医生也无从挽回。不过，近来赛迪莱妮与来自岛舰的狙击手花音相处融洽，她不但醉心于花音绘制的漫画，有时还会向花音展示她那些后现代风格的蜡笔涂鸦，仿佛将花音的身影与某位重要的人重叠。按照花音的说法，那些涂鸦最常见的主题是“姐姐”和“爸爸”，或许赛迪莱妮在惨遭改造之前也曾拥有一个温馨幸福的家。',
      Voiced_name1: 'Emi Lo',
      Voiced_name2: '小林优',
      Voiced_name3: '佟心竹',
      phrase1: '我叫赛迪莱妮。只要让我上前线就可以，只有最前线能让我兴奋，哈哈哈，你懂吗？',
      phrase2: '我闻到了战火的焦味儿。',
      phrase3: '哈哈哈，真是杰作啊，地狱火。',
      mecha_number: '机体编号：SLM-X143-2',
      mecha_head_height: '头顶高：17.3 米',
      mecha_empty_weight: '空重：41.5 吨',
      mecha_full_weight: '全重：54.6 吨',
      mecha_story_desc:
        '这台“地狱火”与世人熟知的量产型号有很大不同，狰狞的装甲轮廓与它的驾驶员一样令人望而生畏。在被S.H.A.D.O.W.行动队收编之前，该机曾是巨企“风标航运”旗下最凶狠的斗犬之一，仅仅一年就踏遍全球战场、击坠无数久经沙场的对手，不少有头有脸的驾驶员都曾是它的手下败将，甚至有人将它视为天灾的化身唯恐避之不及。该机入队时曾在队内引发很大争议，许多人担忧接纳这台风标航运的名机会败坏组织来之不易的好名声。好在到头来还是认为“关键不在兵器，而在是谁使用兵器”的声音占了上风，行动队决定接纳这台机兵和它的主人。尽管至今仍有队员心存疑虑，但这台凶悍的机兵早已赢取了更多人的信赖。',
      mecha_factory_name: '萨勒姆电气'
    },
    luminae: {
      driver_role_title: '卢米纳尔-角色经历',
      driver_sex: '性别：女',
      driver_birth_place: '出生地：沃图里亚战略同盟 济安',
      driver_mecha_name: '搭乘机体：卢米纳尔 特装型',
      driver_role_desc:
        '在没有出击任务的时候，夏莉也不会闲下来，她会到机库协助整备班进行维修。这是她当年带着妹妹在边境地区追随救助队期间学到的技艺。因此，作为“机械达人”的向蕊也将她视作交流的好友。 夏莉温暖的笑容之下，是她如今必须依靠义肢才能行走的现实。边境战争让她失去了双腿，但她不愿被怜悯，无需任何人“照顾”自己，她会像过去那样生活。当年的袭击过后，救援队并未在废墟中找到夏莉，她一度被认定为失踪，直至数月前，夏莉才终于被肆处奔走、坚信自己还活着的妹妹带回边境路网。期间她在阿尔伯特机关的遭遇，令她的记忆有了损伤，她始终无法连贯地回想起这些年的所有经历。不过她并未对此过于苦恼，在她看来，比起曾经被“灌输”的那些虚假记忆，至少她现在找回了真正的家人与自己。',
      Voiced_name1: 'Erica Luttrell',
      Voiced_name2: '菲鲁兹·蓝',
      Voiced_name3: '陈婷婷',
      phrase1: '你好！放心，卢米纳尔在，一切安全~',
      phrase2: '我的修理机器人好用吗？哼~',
      phrase3: '是我，卢米纳尔制胜全场！',
      mecha_number: '机体编号：NGL-SR30',
      mecha_head_height: '头顶高：15.7米',
      mecha_empty_weight: '空重：19.8 吨',
      mecha_full_weight: '全重：23.1 吨',
      mecha_story_desc:
        '这台机兵是“卢米纳尔”开发阶段建造的原型机之一。它在建造之初仅是一台乏善可陈的工程用二代机兵，但月海共同体经兀廷渠道获得解限型机兵原型“白虹”后惊觉新时代已然迫近，紧急要求诺格月球公司将在研的“卢米纳尔”修改为解限型机兵。这台机兵因此加装了彼时尚不成熟的解限型意识投影系统，为日后的一系列“意外”埋下了隐患。类似于同时期的其他测试原型，该机缺乏对驾驶员的必要保护。驾驶员的心智经解限系统介导，向周遭环境完全开放。极度敏锐的感官将超量信息传入大脑，会对驾驶员造成严重的精神负荷。不知是幸运还是不幸，当前的驾驶员早已适应这台危险机体，远超他人的长期磨合让这台“支援机”在她手中成为令人胆寒的强敌。',
      mecha_factory_name: '诺格月球公司'
    },
    panther: {
      driver_role_title: '黑豹-角色经历',
      driver_sex: '性别：男',
      driver_birth_place: '出生地：希古尼亚联合体 穆斯佩尔海姆王国',
      driver_mecha_name: '搭乘机体：黑豹 特装型',
      driver_role_desc:
        '自加入S.H.A.D.O.W.起，沃纳·恩斯特一直是公认的最难以接近的驾驶员之一。他总是游离于众人之外独自沉思，除了必要的作战交流外几乎不与他人攀谈，只有他的旧识才知道，过去的他并非如此。他曾是人人称赞的模范贵族青年，家族的骄傲，堂弟最喜爱的“骑士”；也是拥有众多追随者的领袖，意气风发的精英驾驶员。边境战争时期，沃纳因打击军火走私惹上冥河防务。他与堂弟克劳斯执行任务时陷入对方陷阱：地下城爆炸导致克劳斯失联、平民死伤，沃纳因“指挥失误”被军事法庭审判。服刑结束后，他担心牵连家人而选择独自流亡边境，一边寻找冥河防务陷害自己的证据，一边打探堂弟克劳斯下落。几经辗转，他总算找到克劳斯，二人带领民兵组织“瓦哈特”在边境当地立足。为保护他们，沃纳又化名“贝恩”进入冥河防务，以“孤狼”之名蛰伏。他在黑暗中守护微光，虽然尚未想清骑士之道能否解决乱世争端，却始终践行“只为守护弱者拔剑”的誓言。',
      Voiced_name1: 'Daman Mills',
      Voiced_name2: '梅原裕一郎',
      Voiced_name3: '李嘉祥',
      phrase1: '我就是沃纳·恩斯特，呵，S.H.A.D.O.W.这名头倒是与我非常相配。',
      phrase2: '这次是要正面交锋么？',
      phrase3: '黑豹会信守保护弱者的承诺！',
      mecha_number: '机体编号：UBP-A04C',
      mecha_head_height: '头顶高：16.7米',
      mecha_empty_weight: '空重：23.5 吨',
      mecha_full_weight: '全重：29.9 吨',
      mecha_story_desc:
        '这台“地狱火”与世人熟知的量产型号有很大不同，狰狞的装甲轮廓与它的驾驶员一样令人望而生畏。在被S.H.A.D.O.W.行动队收编之前，该机曾是巨企“风标航运”旗下最凶狠的斗犬之一，仅仅一年就踏遍全球战场、击坠无数久经沙场的对手，不少有头有脸的驾驶员都曾是它的手下败将，甚至有人将它视为天灾的化身唯恐避之不及。该机入队时曾在队内引发很大争议，许多人担忧接纳这台风标航运的名机会败坏组织来之不易的好名声。好在到头来还是认为“关键不在兵器，而在是谁使用兵器”的声音占了上风，行动队决定接纳这台机兵和它的主人。尽管至今仍有队员心存疑虑，但这台凶悍的机兵早已赢取了更多人的信赖。',
      mecha_factory_name: '比弗罗斯特工业集团'
    }
  },
  mecha_unit_list: {
    mechaName1: '鸣神特装型',
    mechaName2: '白虹特装型',
    mechaName3: '飞景特装型',
    mechaName4: '矛隼特装型',
    mechaName5: '赤霄特装型',
    mechaName6: '三角龙特装型',
    mechaName7: '地狱火试验型',
    mechaName8: '卢米纳尔试验型',
    mechaName9: '黑豹试验型'
  },
  game_play: {
    text: '查看詳情'
  }
};

export default mergeLocalesData(pageLocalesData);
